import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=d668ca8c&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d668ca8c')) {
      api.createRecord('d668ca8c', component.options)
    } else {
      api.reload('d668ca8c', component.options)
    }
    module.hot.accept("./LayoutDefault.vue?vue&type=template&id=d668ca8c&", function () {
      api.rerender('d668ca8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/default/LayoutDefault.vue"
export default component.exports